import { render } from "./LevelListSort.vue?vue&type=template&id=ddbe5fd2&ts=true"
import script from "./LevelListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./LevelListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/level/components/LevelListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddbe5fd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddbe5fd2', __exports__)) {
    api.reload('ddbe5fd2', __exports__)
  }
  
  module.hot.accept("./LevelListSort.vue?vue&type=template&id=ddbe5fd2&ts=true", () => {
    api.rerender('ddbe5fd2', render)
  })

}


export default __exports__